import { z } from "zod";

export interface LegalContentConfig {
  domain: string;
  contactEmail: string;
  contactPhone: string;
  companyName: string;
  legalEntity: string;
  address?: string;
}

export const legalSlugSchema = z.enum(["terms", "returns", "privacy", "shipping"]);
export type LegalSlug = z.infer<typeof legalSlugSchema>;